import { Component, Inject } from "@angular/core";
import { MdSnackBar, MdDialogRef, MD_DIALOG_DATA } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import { Subscription } from "rxjs/Subscription";
import { AdalService } from "../../shared/adal.service";
import * as moment from 'moment';

@Component({
  selector: "dialog-result-example-dialog",
  template: require('./revisionhistory.component.html'),
  styles: [require('./revisionhistory.component.css')],
})
export class PageLayoutRevisionHistoryComponent {
  private sub: Subscription;
  historyData;
  Title: any;
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MdSnackBar,
    private adalService: AdalService,
    private productReleaseService: ProductReleaseService,
    public dialogRef: MdDialogRef<PageLayoutRevisionHistoryComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    document.body.style.overflow="hidden";
    //Check Authentication
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close();
      document.body.style.overflow="auto";
      this.router.navigate(["login"]);
    }
    if (this.data.SubProductName != "")
      this.Title =
        "Release History Of " +
        this.data.ProductName +
        " [" +
        this.data.SubProductName +
        "] " +
        " Release No " +
        this.data.ProductReleaseNo;
    else
      this.Title =
        "Release History Of " +
        this.data.ProductName +
        " Release No " +
        this.data.ProductReleaseNo;

    this.getProductReleaseHistory(this.data.ProductReleaseId);
  }

  UTCToLocalTimeZone(date) {
    var stillUtc = moment.utc(date).toDate();
    let theDate = moment(stillUtc).local();
    return theDate.toLocaleString();
  }
  getProductReleaseHistory(ProductReleaseId: number) {
    this.productReleaseService.ViewHistory(ProductReleaseId).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.historyData = data.DataObject;

          this.historyData.forEach((element) => {
            if (element.Role == 1) {
              element.Role = "Developer";
            } else if (element.Role == 2) {
              element.Role = "QA";
            } else {
              element.Role = "Product Management";
            }
          });
        } else {
          this.snackBar.open(data.Error, "", {
            duration: 2000,
          });
        }
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }
  onCancel(): void {
    this.dialogRef.close(true);
    document.body.style.overflow="auto";
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/revision-history/revisionhistory.component.ts